/**
 * Target guards for gesture start gating: resolve a gesture `EventTarget` to an
 * element so a recognizer can decide whether to engage. Pure DOM predicates —
 * no Solid, no recognizer. Trimmed to what the journal swipes actually use.
 */

function asElement(target: EventTarget | null): Element | null {
  if (target instanceof Text) {
    return target.parentElement;
  }
  return target instanceof Element ? target : null;
}

/** True if `target` (or an ancestor) matches `selector`. */
export function closestSelector(target: EventTarget | null, selector: string): boolean {
  const el = asElement(target);
  return Boolean(el?.closest(selector));
}
